module.exports = __webpack_public_path__ + "img/loader.d0b367fa.gif";